<template>
    <div class="row panel-body">
        <issue-quiz-locale-correction-question
                v-for="(question, idx) in questions"
                :key="idx"
                :idx="idx"
                :qid="question.qid"
                :type="question.type"
                :level="parseInt(question.level)"
                :suggestedAnswerOid="question.suggestedAnswerOid"
                :originText="question.text[originLocale]"
                :translation="question.text[destLocale]"
                :options="question.options"
                :pictureUrl="question.pictureUrl"
                :language="language"
                :country="country"
                :destLocale="destLocale"
                :destCountry="destCountry"
                :originLanguage="originLanguage"
                :originLocale="originLocale"
        ></issue-quiz-locale-correction-question>

        <div class="row">
            <div class="col-xs-4 col-xs-offset-4">
              <label>Assign To:</label>
              <select name="assignedTo" id="assignedTo" class="form-control">
                <option selected value=null>Do not assign</option>
                <option disabled>──────────</option>
                <option v-if="userHasMission"
                        :value="this.userId"
                        v-text="this.username + ' (Self-Assign)'"></option>
                <option v-if="userHasMission" disabled>──────────</option>
                <option v-if="hasOriginalTranslator"
                        :value="this.originalTranslatorId"
                        v-text="this.originalTranslatorName + ' (Original Task User)'"></option>
                <option v-if="hasOriginalTranslator" disabled>──────────</option>
                <template v-for="assignableUser in assignableUsers">
                  <option
                        v-if="assignableUser.id !== originalTranslatorId"
                        :value="assignableUser.id"
                        v-text="assignableUser.name">
                  </option>
                </template>
              </select>
            </div>
            <div class="col-xs-4 text-center">
                <submit-button title="Submit"></submit-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            questionsJson: String,
            language: String,
            country: String,
            destLocale: String,
            destCountry: String,
            originLocale: String,
            originLanguage: String,
            eligibleUsers: String,
            userId: String,
            originalTranslatorId: String,
            originalTranslatorName: String,
        },

        data: function() {
            return {
                questions: [],
                assignableUsers: [],
                username: '',
                hasOriginalTranslator: false,
                userHasMission: false,
            };
        },

        mounted() {
            let questions = JSON.parse(this.questionsJson);
            let tmpQuestionsArray = [];
            for (let idx in questions) {
              if (!('suggestedAnswerOid' in questions[idx])) {
                    questions[idx].suggestedAnswerOid = null;
                }
                tmpQuestionsArray.push(questions[idx]);
            }
            // don't push to this.questions inside of the loop, because it triggers re-rendering in every iteration.
            this.questions = tmpQuestionsArray;

            let jsonUsers = JSON.parse(this.eligibleUsers);
            let user = jsonUsers.find(el => el.id === parseInt(this.userId));
            this.username = user?.name;
            this.userHasMission = user !== undefined;

            this.assignableUsers = jsonUsers
                .filter(el => el.id !== parseInt(this.userId))
                .filter(el => el.id !== parseInt(this.originalTranslatorId));
            if (Boolean(this.originalTranslatorId) && Boolean(this.originalTranslatorName)) {
              this.hasOriginalTranslator = true
            }
        },
    };
</script>
